import { Button } from '@material-ui/core'
import { useStyles } from './style'
export function ButtonPrimary({
  label,
  type,
  className,
  variantColor = 'primary',
  loading,
  disabled,
  icon: Icon,
  ...rest
}) {
  const classes = useStyles()

  const variantClass =
    variantColor === 'success' ? classes.success : classes.primary
  return (
    <Button
      variant="contained"
      color="primary"
      {...rest}
      disabled={disabled || loading}
      type={type}
      className={[classes.button, variantClass, className]
        .filter(Boolean)
        .join(' ')}
    >
      {Icon && <Icon className={classes.icon} aria-hidden="true" size={16} />}
      {label}
    </Button>
  )
}
